import type { VoidFunctionComponent } from 'react';
import type { PackageLabelAssignment } from '../../../../../../../shared/dependenciesV2';
import type { IconClassName } from '../../../../../generic';
import { Badge, BadgeColors, icons } from '../../../../../generic';
import DynamicShowMoreList from '../../../../../generic/DynamicShowMoreList';
import styles from './DetailsRow.module.less';

type PackageLabelBadgeProps = {
  label: PackageLabelAssignment;
};

/**
 * A badge that displays a Package Label
 */
const PackageLabelBadge: VoidFunctionComponent<PackageLabelBadgeProps> = ({ label }) => {
  let icon: IconClassName = icons.globeOutline;
  if (label.scope === 'project') {
    icon = icons.locationDot;
  } else if (label.scope === 'revision') {
    icon = icons.codeCommit;
  }

  return (
    <Badge
      color={BadgeColors.White}
      icon={icon}
      fullWidth
    >
      {label.name}
    </Badge>
  );
};

const labelScopeRanking: Record<PackageLabelAssignment['scope'], number> = {
  revision: 1,
  project: 2,
  org: 3,
};

type Props = {
  labels?: PackageLabelAssignment[];
};

/**
 * List of labels
 */
const LabelsSection: VoidFunctionComponent<Props> = ({ labels }) => {
  if (!labels?.length) {
    return null;
  }

  const badges = labels.sort((a, b) => {
    if (labelScopeRanking[a.scope] < labelScopeRanking[b.scope]) {
      return -1;
    }
    if (labelScopeRanking[a.scope] > labelScopeRanking[b.scope]) {
      return 1;
    }

    return a.name.localeCompare(b.name);
  }).map((label) => {
    return <PackageLabelBadge label={label} key={label.id} />;
  });

  return (
    <div className={styles.licenseList}>
      <DynamicShowMoreList list={['Labels ', ...badges]} lineHeight={27} />
    </div>
  );
};

export default LabelsSection;
